<template>
  <div class="sidebar">
    <!--    NEWS-->
    <div class="section search-form">
      <div class="row">
        <div class="col">
<!--          <div class="main-form sidebar-form ic-form itinerary-form">-->
            <itinerary-adv-form localization="sidebar"></itinerary-adv-form>
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="section news">
      <div class="row">
        <div class="col">
          <div class="title">
            <p>Aktualności</p>
            <h2>Sprawdź także</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ul class="list-icons list-unstyled">
            <li><a href="#">Zmiany w tabeli  kursowania pociągów Intercity</a> </li>
            <li><a href="#"> W czasie pandemii Fitch potwierdza długoterminowy rating PKP Intercity na poziomie BBB+</a></li>
            <li><a href="#">Apel PKP Intercity: zaplanujmy wcześniej podróże w związku z 1 listopada</a></li>
            <li><a href="#">Zmiany w tabeli  kursowania pociągów Intercity</a></li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-outline-primary mb-3 mt-0 mb-md-auto mt-md-auto">
            Zobacz więcej
          </button>
        </div>
      </div>
    </div>
    <!--    Newsletter-->
    <div class="section newsletter-form">
      <div class="row">
        <div class="col">
          <div class="title">
            <p>Newsletter</p>
            <h2>Bądz na bieżąco</h2>
          </div>
          <p>
            Jeżeli chcesz otrzymywać informacje o planowanych zmianach w rozkładach jazdy, nowych promocjach zapisz się do naszego newslettera.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <form class="g-3 needs-validation ic-form" novalidate>
            <div class="input-group mb-3 icon icon__envelope">
              <input type="email" class="form-control" id="" placeholder="Adres e-mail">
            </div>
            <div class="m-1 mt-3">
                <div class="form-check mt-3">
                  <input class="form-check-input" type="checkbox" value="" id="invalidCheck" required>
                  <label class="form-check-label font-size-xs" for="invalidCheck">
                    Wyrażam zgodę na przetwarzanie moich danych osobowych, zgodnie z Rozp. Parlamentu Europejskiego i Rady (UE) 2016/679.
                    kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.
                  </label>
                </div>
                <button type="submit" class="btn btn-info mt-3">Zapisz się</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ItineraryAdvForm from "../components/forms/itinerary-adv-form-module";

export default {
  name: 'section-sidebar',
  components: {
    ItineraryAdvForm
  },
  data() {
    return {}
  }
}
</script>